<template>
    <div class="p-3">
      <b-modal id="modal-sm" size="md" title="Edit EDS Criteria" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
          <div slot="default">
            <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
            <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
          </div> 
          <div slot="modal-footer" class="w-100">
                <p class="float-left" variant="primary"></p>
                <b-button variant="primary"  size="md"  class="float-right"  @click="Exit()"> Close </b-button>
          </div>
      </b-modal>

      <b-modal modal-class="test-modal fade"
      id="phModal"   v-model="ShowEds"  no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <EditCriteria   @criteriadone="closestdModal" @loadmainedstbl="LoadEdstbl" :CrData="criteriaData"></EditCriteria>
     <template slot="modal-header"   slot-scope="{ close }"> 
        <div>
        <small class="PopUpTitle w-100 text-left ml-2"> Edit EDS Criteria</small>
      </div> 
      <!-- <div v-show="Button=='Add'"></div> -->
    </template>  
</b-modal>
      

      <!-- <b-table striped hover :items="rowdata" :fields="fields"></b-table> -->


      <div class="form-row">
        <div class="form-group col-sm-2">
          <label for="user" class="label-small"><b class="text-left">User Type:</b></label>
            <p class="row no-gutters" id="user">{{rowdata[0].usertype}}</p>
        </div>

        <div class="form-group col-sm-2">
          <label for="eds" class="label-small"><b>Brand/Generic Name:</b></label>
            <span class="row no-gutters" id="eds">{{rowdata[0].eds}}</span>
        </div>

        <div class="form-group col-sm-3">
          <label for="dosage" class="label-small"><b>Dosage:</b></label>
            <span class="row no-gutters" id="dosage">{{rowdata[0].dosage}}</span>
        </div>

        <div class="form-group col-sm-1">
          <label for="din" class="label-small"><b>Din:</b></label>
            <span class="row no-gutters" id="din">{{rowdata[0].din}}</span>
        </div>

        <div class="form-group col-sm-1">
          <label for="from" class="label-small"><b>Effective Date:</b></label>
            
          <span class="row no-gutters" id="from">{{ EffectiveDate }}</span>
        </div>

        <div class="form-group col-sm-2">
          <label for="todate" class="label-small"><b>Expiry Date:</b></label>
          <div>
         
             <datepicker  
                :disabledDates="disableExpDate"
                :disabled= "IsPast"
                type="date"
                class="servdatapick"
                :open-date="new Date()"
                v-model="toDate"
                :format="DateFormat"
                id="todate"
                :bootstrap-styling="true"
                :input-class="datapickClass"
                name="toDatepicker"
            ></datepicker> 
        
        </div>
        <div  class="row" v-show="$v.toDate.$error">
            <div class="col-sm-12">     
              <small class="sml-red" v-if="!$v.toDate.required">To Date is required.</small>            
              <small class="sml-red" v-if="!$v.toDate.ValidValue">To Date is invalid.</small>              
            </div>
        </div>  
        </div>
        

        <div class="form-group col-sm-1 mt-4">
            <button v-on:click="UpdateEds()" type="button" class="btn btn-primary btn-sml" :disabled= "IsPast">
              Update
            </button>
        </div> 
      </div>

 
  <v-client-table ref="table" :columns="columns" :data="TblData" :options="options" v-if="TblData.length>0">  
    <div slot="beforeTable"  class="form-group row VueTables_Adduser Maintitle mr-1 ml-1"> 
            <div class="col-4 float-left mt-1 pl-1">
              <strong>EDS Criteria</strong>
            </div>  
    </div>
    <span class="pointer" v-on:click="ShowCriteria(props.row)" slot="Edit" slot-scope="props" > <i class="far fa-edit"></i></span>  
  </v-client-table> 

    </div>
  </template>
  
  <script>
   import Vue from 'vue';
      import {mapGetters} from 'vuex'
      import moment from 'moment'
      import axios from 'axios'
      import Datepicker from 'vuejs-datepicker';
      import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
      import Subtitle from '@/Common/Default/SubTitle.vue';
      import Modal from '@/Common/ModelPop.vue';
      import Card from "@/Common/Card.vue";
      import CardBody from "@/Common/CardBody.vue";
      import TileNote from "@/Common/TileNote.vue";
      import { PopUpVariant } from '@/Common/Default/PopUpVariant';
      import { request } from 'http';
      import Vuelidate from 'vuelidate'
  
      import EditCriteria from '@/components/DPEBB/Administrator/EditCriteria.vue'
      Vue.use(Vuelidate);
      import {helpers, required, minLength, sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
      import { ref } from 'vue' 
      const checkedNames = ref([]);
  export default {
      props:
      {
        useredsid: 0, 
        tblRow: 0,
      },
      data: function () {
      return {
        criteriaData: '',
        PopUpVar:PopUpVariant,
        ShowEds: false,
        isEditing :  true,
        fields: [
      
          //expirydate
            {
              key: 'usertype',
              label: 'User Type', 
            },
            {
              key: 'eds',
              label: 'Brand/Generic Name',
              //sortable: false
            },
            {
              key: 'dosage',
              label: 'Dosage', 
            },
            {
              key: 'din',
              label: 'Din',
              //sortable: true,
              // Variant applies to the whole column, including the header and footer
              //variant: 'danger'
            },
            {key:'effectivedate', label :'Effective Date' ,formatter: "momentdate" },
          {key:'expirydate', label :'Expiry Date' ,formatter: "momentdate"},
          ],
          // fields: [
          //   {
          //     key: 'usertype',
          //     label: 'User Type', 
          //   },
          //   {
          //     key: 'eds',
          //     label: 'Brand/Generic Name',
          //     //sortable: false
          //   },
          //   {
          //     key: 'dosage',
          //     label: 'Dosage', 
          //   },
          //   {
          //     key: 'din',
          //     label: 'Din',
          //     //sortable: true,
          //     // Variant applies to the whole column, including the header and footer
          //     //variant: 'danger'
          //   }
          // ],
      
      rowdata  : [], 
      //UserType : this.rowdata.usertype,
      allMarked:false,
      EffectiveDate: '',
      toDate: '',
      selectedRole: '',
      succeeded: false,
      Msg:'',
      showModal:false,
      datapickClass: "form-control form-control-xs my-0",
      disableExpDate: { to: new Date(Date.now() - 8640000) },
      todayDate: moment().format('YYYY/MM/DD'),
      IsPast: false,
      markedRows:[], 
      TblData: [],
      columns: ['Edit', 'diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter',
                'commentallow','allowexpedit','openexpdate','createdby','modifyby'],
      //columns: ['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter',
      //'commentallow','createdby','modifyby'],
      options: {
        uniqueKey: 'useredsid',
        editableColumns: ['diagnosis'],
        texts:{
          //count:"Showing {from} to {to} of {count} records|{count} records|One record",
          first:'First',
          last:'Last',
          //limit:"Records:",
          //page:"Page:",
          noResults:"No Criteria Record Found",
          filterBy:"Filter by {column}",
          loading:'Loading...',
          defaultOption:'Select {column}',
          columns:'Columns'
        },
        headings: { 
          id:"Select Criteria",
          //status: "Status",
          diagnosis: "Diagnosis",
          criteria: "Criteria",
          maxedunit: "Max Unit",
          maxedslength: "Max Length",
          minage:"Min Age",
          maxage:"Max Age",
          generateletter:"Generate Letter",
          commentallow:"Comment Allow",
          allowexpedit: "Expiry Date Editable",
          openexpdate: "Open Expiry Date",
          createdby: "Created By",
          modifyby: "Modify By"
        },
  
        responseAdapter({data}) {
          return {
            data: formatData,
            count: data.length
          };
        },
        summary: false,
        caption: false,
        perPage:5,
        perPageValues:[5],
        dateColumns:['effectivedate','expirydate'],
        footerHeadings: false,
        filterable: true,
  
        // listColumns: {
        //   claimtype: [
        //     {id: "CL",
        //     text: "Claim"},
        //     {id: "PA",
        //     text: "Prior Approval"}
        //   ]
        // },
  
        templates: { 
          status(h, row) {
              if(row.status ==true)
              return "Active"
          else
          return  "Inactive"
          },
          commentallow(h, row) {
              if(row.commentallow == 'N')
              return "Not Allowed"
          else if(row.commentallow == 'R') // Optional
          return  "Required"
          else if(row.commentallow == 'O') // Optional
          return  "Optional"
          },  
  
          maxedunit(h, row) {
              if(row.maxedunit == 'D')
              return "Days"
          else if(row.maxedunit == 'M') // Optional
          return  "Month"
          else if(row.maxedunit == 'Y') // Optional
          return  "Year"
          }, // maxedunit
  
          generateletter(h, row) {
              if(row.generateletter ==true)
              return "YES"
          else
          return  "NO"
          },
          allowexpedit(h, row) {
              if(row.allowexpedit ==true)
                return "YES"
              else
                return  "NO"
          },
          openexpdate(h, row) {
            if(row.openexpdate ==true)
              return "YES"
            else
              return  "NO"
          },
          effectivedate(h, row) {
            return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
          expirydate(h, row) {
            return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
      
        },
  
  
       pagination: {
              edge: true,
              nav: 'scroll',
              chunk: 5
            },
            sortable: ['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','allowexpedit','openexpdate','createdby','modifyby'],
            filterable: '',//['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','createdby','modifyby'],
            sortIcon: {
                    base : 'fas',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down'
                    },
      },
      }
      },
      components: {
            Datepicker,
            EditCriteria
      },

      validations(){
      return {  
        toDate :{
            required,
             ValidValue : value => this.ValToDate(),  
          },
        }
      },

      filters: {
            moment: function (date) {
              return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
            },
            stringify(value) {
              return JSON.stringify(value, null, 2)
            }  
          }, 
          computed: {
      currentRouteName() {
          return this.$route.name;
      }
  },
      methods: 
      
      {
        
        ShowCriteria(row){
          //console.log(' row ' + row.criteriaid )
          this.criteriaData = row;
          this.ShowEds = true;
          
        },

        LoadEdstbl(){

        },
        closestdModal( ){
          this.loadTable();
            this.ShowEds = false;
            //console.log('at close')
          
        },
        momentdate: function (date) {
              return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
            },
        ClearAll() {
        //this.selectedOptions = [];
        // this.$emit('change', {
        //   changed: null,
        //   selected: []
        // });
        this.$emit("exitpage", "EDSID");
      },
  
      Exit() {
        //this.selectedOptions = [];
        // this.$emit('change', {
        //   changed: null,
        //   selected: []
        // });
        this.$emit("criteriadone");
        this.loadTable();
      },

      ValToDate(){
        
        if((this.fromDate != '' && this.fromDate != null))
          
        {
           if (this.toDate == '' || this.toDate != null)
            return true;
            else
            return false;
        }
        else
        {
           return true;
        }        
      },
  
      GetUserEds(){
        //console.log('eds id =  '+ this.useredsid)
            var vm = this;      
            vm.searched = false;
            var params = new URLSearchParams();            
             params.append('edsrec',  this.useredsid);         
             axios.get('SaskHealthApi/Codes/GetUsersEDSAllocation?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             .then(function (response) {
                 //vm.TblData=response.data; 
                 //var r   = JSON.parse(JSON.stringify(response.data))
                  vm.rowdata.push(response.data[0])
                  //console.log(vm.rowdata)             
              })
              .catch(function (er) {
                  //console.log(er)
              });
      },
      
      UpdateEds(){
        //this.$v.$touch();
          
          //if (!this.$v.$invalid){  
           //  //console.log('here')
          var vm = this; 
          var expiryDate = moment(vm.toDate,"YYYY-MM-DD").format('YYYY/MM/DD');
          var Id = vm.rowdata[0].id;
          var url = "/SaskHealthApi/Codes/PostEditEDSStandard/"
          var params = {
                "ID" : Id,
                "ExpiryDate": expiryDate,
                } 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                 // //console.log(response)
                  if(response.status ==200)
                  {
                    if(response.data.succeeded)
                    {
                          vm.succeeded = true;
                          vm.Msg=  "Successfully updated in to the system.";  
                          vm.showModal=true;  
                          vm.loadTable();
                    }
                    else if(!response.data.succeeded)
                    {
                          
                          vm.succeeded = false;
                          vm.Msg= response.data.errors;  
                          vm.showModal=true;
                    }
                    else
                    {
                          vm.succeeded = false;
                          vm.Msg="System Error; Expiy Date is not successfully saved."; 
                           vm.showModal=true; 
                    }
                  }
                  else
                  {
                        vm.succeeded = false;
                        vm.Msg="System Error; Expiry Date is not successfully saved."; 
                          vm.showModal=true; 
                  }
                   
                })
                .catch(function (error) {
                    if (error.response) {
                     ////console.log(error.response.data);
                      ////console.log(error.response.status);
                      if(error.response.status ==500)
                      {                   
                          vm.succeeded = false;
                          vm.Msg="System Error; Expiry is not successfully saved."; 
                          vm.showModal=true; 
                      }
                      ////console.log(error.response.headers);
                    }
                    //console.log(error)
                }); 
          //}
          
      },
  
      loadTable()
      {
  
      var vm = this;
      vm.searched = false;
      var params = new URLSearchParams();
       params.append('usergroupid', this.tblRow.id);
       //params.append('usergroupid', this.useredsid);
       axios.get("SaskHealthApi/Codes/GetEDSCriteria", {headers: { Authorization: "Bearer " + localStorage.access_token },params,})
      .then(function (response) {
           vm.TblData=response.data;
           
        })
        .catch(function (er) {
                      //console.log(er)
                  }).then(function () {
  
                    vm.markedRows=[];
                     // vm.tableData.push(response.data);
                    //  for(let i = 0; i <  vm.TblData.length; i++){
                    //       ////console.log(vm.TblData[i].id)
                    //       if(vm.TblData[i].id>0)
                    //       {
                    //         // alert(vm.tableData[i].haspermission)
                    //           vm.markedRows.push(vm.TblData[i].id);
                    //       }
                    //   }
  
                      ////console.log('at fill ' + vm.markedRows)
                  }); 
      },
      showMsg(msg,data,Title) {
          this.boxTwo = ''
          this.$bvModal.msgBoxOk(msg, {
          title: Title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Close',
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
          .then(value => {
  
  
            this.boxTwo = this.msg;
            if(value)
            { 
              this.$emit("exitpage", this.currentRouteName);
              // this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
              //   //console.log('Modal is about to be shown', bvEvent, modalId)
              // })
              //this.$route.push("EDSStandard")
                //console.log(value)
            }
          })
          .catch(err => {
            // An error occurred
          })
      
      },
  },
  
  
      created: function() {
              // //console.log(this.tblRow)
              var r   = JSON.parse(JSON.stringify(this.tblRow))
              //this.usertype= r.usertype;
              this.rowdata.push(r)
              //console.log(this.rowdata)
              this.EffectiveDate = moment(this.rowdata[0].effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');
              this.toDate = moment(this.rowdata[0].expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');
              if(this.todayDate > this.toDate){
                this.IsPast = true;
              }
              //vm.disableExpDate = { from: new Date(this.fromDate), to: new Date(this.disableEffecDate.to) };
              //this.GetUserEds();
               this.AppServiceID = 1;//this.Type;
  
               if(this.AppServiceID == 3)
               {
                 this.AppName = "Optical";
               }
               else if(this.AppServiceID == 4)
               {
                 this.AppName = "Hearing";
               }
               else if(this.AppServiceID == 5)
               {
                 this.AppName = "Podiatry";
               }
  
               this.DateFormat = this.$store.getters.GetDateFormat;
               this.loadTable();
             },
  
             beforeCreate: function() {
  
             },
  
             mounted: function () {
      
              // this.$root.$on('loadctr', () => {
              //   //console.log('listening')
                //this.loadTable();
                //})
  
               // var params = new URLSearchParams();
               // var vm = this;
  
               // axios.get('SaskHealthApi/Codes/IsAssessorOrSuper?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
               // .then(function (response) {
               //     // //console.log(response.data);
               //   vm.isAssessor = response.data;
               //     vm.GetUserClinics();
               //     vm.GetProviders();
               // }).catch(function (er) {
               //   //console.log(er)
               // });
  
  
             },
  }
  </script>
  
  <style>
  @import url(//netdna.bootstrapcdn.com/font-awesome/4.2.0/css/font-awesome.css);
  
  /*** basic styles ***/
  /* 
  body { margin: 20px; }
  h1 { font-size: 1.5em; }
  label { font-size: 18px; }
  container {
    width: 175px;
    margin-left: 20px;
  } */
  
  input[type=radio].with-font,
  input[type=checkbox].with-font {
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
  }
  
  input[type=radio].with-font ~ label:before,
  input[type=checkbox].with-font ~ label:before {
      font-family: FontAwesome;
      display: inline-block;
      content: "\f1db";
      letter-spacing: 10px;
      font-size: 1.2em;
      color: #535353;
      width: 1.4em;
  }
  
  input[type=radio].with-font:checked ~ label:before,
  input[type=checkbox].with-font:checked ~ label:before  {
      content: "\f00c";
      font-size: 1.2em;
      color: darkgreen;
      letter-spacing: 5px;
  }
  input[type=checkbox].with-font ~ label:before {
      content: "\f096";
  }
  input[type=checkbox].with-font:checked ~ label:before {
      content: "\f046";
      color: darkgreen;
  }
  input[type=radio].with-font:focus ~ label:before,
  input[type=checkbox].with-font:focus ~ label:before,
  input[type=radio].with-font:focus ~ label,
  input[type=checkbox].with-font:focus ~ label
  {
      color: green;
  }
  
  .checkbox label:after {
    content: '';
    display: table;
    clear: both;
  }
  
  .checkbox .cr {
    position: relative;
    display: inline-block;
    border: 1px solid #a9a9a9;
    border-radius: .25em;
    width: 1.2em;
    height: 1.2em;
    /* float: left; */
    margin-right: .5em;
  }
  
  .checkbox .cr .cr-icon {
    position: absolute;
    font-size: .7em;
    line-height: 0;
    top: 50%;
    left: 15%;
  }
  
  .checkbox label input[type="checkbox"] {
    display: none;
  }
  
  .checkbox label input[type="checkbox"]+.cr>.cr-icon {
    opacity: 0;
  }
  
  .checkbox label input[type="checkbox"]:checked+.cr>.cr-icon {
    opacity: 1;
  }
  
  .checkbox label input[type="checkbox"]:disabled+.cr {
    opacity: .5;
  }
  
  
  </style>
  